import { Controller } from 'stimulus'
import './checkout_component.scss'

export default class extends Controller {
  static targets = ['paymentElement']

  stripe: Stripe | null = null
  elements: Elements | null = null
  submitted: boolean = false

  connect = (): void => {
    const publishableKey = this.element.dataset.stripePublishableKey
    const accountId = this.element.dataset.accountId

    if (this.hasPublishableKeyAndAccountId === false) {
      console.error('Publishable key or account id not found.')
      return
    }

    this.stripe = new Stripe(publishableKey, {
      betas: ['embedded_checkout_beta_1'],
      stripeAccount: accountId
    })

    this.setupElements().catch((error) => { console.error('An error occurred:', error) })
  }

  async setupElements (): Promise<void> {
    const clientSecret = this.element.dataset.clientSecret

    if (clientSecret === null) {
      console.error('Client secret not found.')
      return
    }

    const checkout = await this.stripe.initEmbeddedCheckout({
      clientSecret
    })

    checkout.mount(this.paymentElementTarget)
  }

  hasPublishableKeyAndAccountId = (): boolean => {
    return this.stripe !== null && this.elements !== null
  }
}
